import ImagesUrl from "#constants/images.js";
import { numberOnly } from "#utils/helpers.js";
import React, { useEffect, useRef } from "react";

const PlacementTableListing = ({
  values,
  handleChange,
  handleAddProduct,
  renderSoilTestInputs,
  handleBlur,
  parentIndex,
  handelRemoveProduct,
  handelRemovePlacement,
}) => {
  return values?.data[parentIndex]?.fertility?.map((item, index) => (
    <div
      className="placement_item_card mb-2"
      key={index}
      id={`placement-${parentIndex}-${index}`}
    >
      <div className="position-relative">
        <div className="new_file_preview_item2 p-2">
          {values?.data[parentIndex]?.fertility.length > 1 && (
            <button
              className="remove_file"
              onClick={() => handelRemovePlacement(parentIndex, index)}
            >
              <i className="fa fa-solid fa-xmark"></i>
            </button>
          )}
        </div>
      </div>

      <div className="placement_header position-relative">
        <div className="row gy-4">
          <div className="col-lg-12">
            <input
              className="form-control text-center"
              placeholder="Enter Placement"
              value={item?.placement || ""}
              name={`data[${parentIndex}].fertility[${index}].placement`}
              onChange={(e) => handleChange(e, index)}
            />
          </div>
        </div>
        {/* {values?.data[parentIndex]?.fertility.length > 1 && (
          <img
            className="position-absolute top-0 end-0 cursor-pointer "
            src={ImagesUrl.deleteIcon}
            alt="..."
            onClick={() => handelRemovePlacement(parentIndex, index)}
          />
        )} */}
      </div>

      <div className="placement_content">
        <div className="placement_info_heading">
          <span>Product (N-P-K-S)</span>
          <span>Rate (lb/ac)</span>
          <span>Actual (N-P-K-S)</span>
        </div>
        <div className="placement_info_body">
          {item?.products?.map((product, productIndex) => {
            return (
              <div className="placement_info_item" key={productIndex}>
                <div className="inline_input">
                  {renderSoilTestInputs(parentIndex, index, productIndex)}
                </div>
                <div className="placement_rate_field">
                  <input
                    className="form-control rate_input"
                    name={`data[${parentIndex}].fertility[${index}].products[${productIndex}].rate`}
                    value={product?.rate || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength="3"
                    onKeyPress={numberOnly}
                  />
                </div>
                <div className="placement_actual_info">
                  {product?.actualValue || "0-0-0-0"}{" "}
                  {item?.products?.length > 1 && (
                    <img
                      src={ImagesUrl.deleteIcon}
                      alt=".."
                      style={{ marginLeft: "10px", cursor: "pointer" }}
                      onClick={() =>
                        handelRemoveProduct(parentIndex, index, productIndex)
                      }
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="placement_footer d-flex justify-content-between align-items-center">
        <button
          className="p-0 border-0 primary_text bg-transparent"
          onClick={() => handleAddProduct(parentIndex, index)}
        >
          + Add Product
        </button>
        <span className="fw-medium">
          Actual Value: &nbsp;
          {item?.actualTotalValue || "0-0-0-0"}
        </span>
      </div>
    </div>
  ));
};

export default PlacementTableListing;
